import { render, staticRenderFns } from "./AllPaymentMethods.vue?vue&type=template&id=afe713aa&scoped=true"
import script from "./AllPaymentMethods.vue?vue&type=script&lang=js"
export * from "./AllPaymentMethods.vue?vue&type=script&lang=js"
import style0 from "./AllPaymentMethods.vue?vue&type=style&index=0&id=afe713aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe713aa",
  null
  
)

export default component.exports